import { FilterItem } from "../../types";

export const getColorsFromFilterItems = (
  items: FilterItem[],
  defaultColor: string,
  callback: (name: string, color: string, defaultColor: string) => string,
) =>
  items?.reduce(
    (prev, { name, color }) => ({
      ...prev,
      [name as string]: callback(name as string, color, defaultColor),
    }),
    {},
  );
